import React, { useContext, useEffect, useState } from "react";
import SupervisorAttendanceView from "./supervisor-attendance.view";
import { LogOut, TrendingUp, UserRoundCheck, UsersRound, UserX } from "lucide-react";
import { StatCardColor } from "../../common/stat-cards/stat-cards";
import { ISupervisorState } from "../attendance.types";
import { fetchTeamSummary } from "./actions";
import { scrollToAttendanceTable } from "../utils";
import AttendanceSearchContext from "../AttendanceContext";

const initialState = {
    summary: {
        previousMonthAttendanceRate: 0,
        currentMonthAttendanceRate: 0,
        totalAbsent: 0,
        totalPresent: 0,
        totalOnLeave: 0,
        totalReportees:0,
    },
    upcomingLeaves: [],
    chartData: {monthlyTrend: [], individualAttendanceRate: []},
    isLoading: false
}

const SupervisorAttendance = ({supervisorId}:{supervisorId:string}) => {

    const [state, setState] = useState<ISupervisorState>(initialState);
    const {setAttendanceSearch}=useContext(AttendanceSearchContext);

    useEffect(() => {
        loadTeamSummary();
    }, []);

    const loadTeamSummary = async () => {
        setState(prev => ({...prev, isLoading: true}));

        try {
            const res = await fetchTeamSummary();
            setState(prev => ({
                ...prev,
                summary: res.countSummary,
                upcomingLeaves: res.upcomingLeaves,
                chartData: res.charts
            }));

        } finally {
            setState(prev => ({
                ...prev,
                isLoading: false
            }));
        }
    };

    const cardData = [
        {
            key: 'attendanceRate',
            label: 'Current Month Attendance',
            value: `${state.summary.currentMonthAttendanceRate}%`,
            icon: TrendingUp,
            color: 'teal' as StatCardColor
        },
        {
            key: 'totalReportees',
            label: 'Reportee Count',
            value: state.summary.totalReportees,
            icon: UsersRound,
            color: 'teal' as StatCardColor
        },
        {
            key: 'present',
            label: 'Present Today',
            value: state.summary.totalPresent,
            icon: UserRoundCheck,
            color: 'green' as StatCardColor,
            onClick:()=>{
                setAttendanceSearch('STATUS','PRESENT');
                scrollToAttendanceTable();
            }
        },
        {
            key: 'absent',
            label: 'Absent Today',
            value: state.summary.totalAbsent,
            icon: UserX,
            color: 'red' as StatCardColor,
            onClick:()=>{
                setAttendanceSearch('STATUS','ABSENT');
                scrollToAttendanceTable();
            }
        },
        {
            key: 'onLeave',
            label: 'On Leave Today',
            value: state.summary.totalOnLeave,
            icon: LogOut,
            color: 'orange' as StatCardColor,
            onClick:()=>{
                setAttendanceSearch('STATUS','ON_LEAVE');
                scrollToAttendanceTable();
            }
        },
    ];

    return (
        <SupervisorAttendanceView
            supervisorId={supervisorId}
            cardData={cardData}
            summary={state.summary}
            upcomingLeaves={state.upcomingLeaves}
            chartData={state.chartData}
            isLoading={state.isLoading}
        />
    )

}


export default SupervisorAttendance;
